<!--肺部CT平扫（可选）-->
<script setup>
import { computed, reactive,ref } from "vue";
import upload from "@/components/upload1.vue"
import { useCrfStore } from "@/stores/crf";
import {useCommonStore} from "@/stores/common.js"
import check from "./check.vue";
const crfStore = useCrfStore();
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div class="title_up">
      <h2>肺部CT平扫（可选）</h2>
      <upload :type="props.type" :data="model" name="fbct"></upload>
      <p class="txt">或进行报告内容填写</p>
      <check :period="props.type" text="肺部CT平扫（可选）" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="肺部CT平扫是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['肺部CT平扫是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['肺部CT平扫是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增肺部CT平扫（可选）':'肺部CT平扫（可选）'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增肺部CT平扫']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>

        </el-form-item>
        <template v-if="crfFields['是否新增肺部CT平扫'] == '是' || !notScreen">
          <el-form-item label="肺部CT平扫" :prop="itemProp('肺部CT平扫')" :rules="crfStore.textRules(`肺部CT平扫`,true)" class="redStar">
            <el-input v-model="crfFields['肺部CT平扫']" type="textarea"></el-input>
          </el-form-item>
        </template>
      </template>
  </template>
</template>

<style lang="scss" scoped>
  .txt{
    padding-top: 10px;
    padding-left: 20px;
    font-size: 14px;

  }
  .title_up{
    display: flex;
    ::v-deep .btn_fiexd{
      width: 120px;
    }

  }
</style>